module.exports = __webpack_public_path__ + "img/Hoogspanning2.a4658ca9.jpg";